<!--
 * @Description:
 * @Autor: xiaona.wang
 * @Date: 2021-07-22 17:11:59
 * @LastEditors: kun.zhang
 * @LastEditTime: 2021-09-15 15:07:53
-->
<template>
  <div class="app_wrap">
    <app-header v-if="isOnlyContent" />
    <div :class="classObj" class="app_body_wrap">
      <div
        v-if="device === 'mobile' && sidebar.opened"
        class="drawer-bg"
        @click="handleClickOutside"
      />
      <sidebar v-if="isOnlyContent" class="sidebar-container" />
      <div :class="{ hasTagsView: needTagsView }" class="main-container main-router-view">
        <div v-if="isOnlyContent" :class="{ 'fixed-header': fixedHeader }">
          <!-- <navbar v-if="!needTagsView" /> -->
          <tags-view />
        </div>
        <app-main />
        <!-- <right-panel v-if="showSeisOnlyContentssubproject">
          <settings />
        </right-panel> -->
      </div>
    </div>
  </div>
</template>

<script>
import RightPanel from "@/components/common/RightPanel";
import { AppHeader, Navbar, Sidebar, AppMain, TagsView } from "./components";
import Settings from "./components/Settings/index";
import ResizeMixin from "./mixin/ResizeHandler";
import { mapState } from "vuex";
export default {
  name: "Layout",
  components: {
    AppHeader,
    Navbar,
    Sidebar,
    RightPanel,
    AppMain,
    TagsView,
    Settings
  },
  mixins: [ResizeMixin],
  data() {
    return {
      isOnlyContent: true // 是否只显示内容（乾坤子应用不显示页头和菜单）
    };
  },
  computed: {
    ...mapState({
      sidebar: state => state.app.sidebar,
      device: state => state.app.device,
      showSettings: state => state.settings.showSettings,
      needTagsView: state => state.settings.tagsView,
      fixedHeader: state => state.settings.fixedHeader
    }),

    classObj() {
      return {
        hideSidebar: !this.sidebar.opened,
        openSidebar: this.sidebar.opened,
        withoutAnimation: this.sidebar.withoutAnimation

        /*
         * 左侧菜单永远显示，不隐藏
         *  mobile: this.device === "mobile",
         */
      };
    }
  },
  mounted() {
    if (window.__POWERED_BY_QIANKUN__) {
      this.isOnlyContent = false;
    }
  },
  methods: {
    handleClickOutside() {
      this.$store.dispatch("app/closeSideBar", { withoutAnimation: false });
    }
  }
};
</script>

<style lang="scss" scoped>
@import "~@/styles/mixin.scss";
@import "~@/styles/variables.scss";

.app_wrap{
  display: flex;
  flex-direction: column;
  flex: 1;
  overflow: hidden;
}
.app_body_wrap {
  @include clearfix;
  display: flex;
  flex: 1;
  position: relative;
  overflow: hidden;
  width: 100%;
  &.mobile.openSidebar {
    position: fixed;
    top: 0;
  }
}
.drawer-bg {
  background: #000;
  opacity: 0.3;
  width: 100%;
  top: 0;
  height: 100%;
  position: absolute;
  z-index: 999;
}

.mobile .fixed-header {
  width: 100%;
}
.main-container {
  display: flex;
  flex-direction: column;
  flex: 1;
  width: 100%;

  .main-router-view {
    height: 100%;
  }

  .main-tabs {
    position: absolute;
    top: 0;
    right: 0;
    left: 0;
    z-index: 10;
  }
}
</style>
